<template>
  <div class="paper-contrast">
    <!-- 段落为空时懒加载 -->
    <div v-if="!loaded" v-loading="loading" class="loading-box">
      <span v-if="!loading" class="empty-tip">暂无论文对照内容</span>
    </div>

    <div v-else class="contrast-list">
      <div
        v-for="(p, i) in paragraphs"
        :key="i"
        class="contrast-item"
      >
        <div class="contrast-title">{{ p.title }}</div>
        <!-- content 为 Markdown 风格自由文本，不引入 markdown 库，原样展示 -->
        <div class="contrast-content">{{ p.content }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { aiParagraphs } from "@/api/ai";

export default {
  name: "PaperContrast",
  props: {
    // 父组件已加载的段落；为空时本组件按 jsonUrl 懒加载
    paragraphs: {
      type: Array,
      default: () => [],
    },
    jsonUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      localParagraphs: [],
    };
  },
  computed: {
    loaded() {
      return this.localParagraphs.length > 0 || this.paragraphs.length > 0;
    },
    renderList() {
      return this.paragraphs.length ? this.paragraphs : this.localParagraphs;
    },
  },
  watch: {
    jsonUrl: {
      immediate: true,
      handler() {
        // 父组件未传段落且存在 jsonUrl 时，懒加载
        if ((!this.paragraphs || !this.paragraphs.length) && this.jsonUrl) {
          this.fetchParagraphs();
        }
      },
    },
  },
  methods: {
    async fetchParagraphs() {
      this.loading = true;
      try {
        const res = await aiParagraphs({ jsonUrl: this.jsonUrl });
        this.localParagraphs = Array.isArray(res) ? res : [];
      } catch (e) {
        this.$message.error((e && e.msg) || "获取论文对照内容失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.paper-contrast {
  .loading-box {
    min-height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    .empty-tip {
      color: #909399;
      font-size: 14px;
    }
  }
  .contrast-list {
    .contrast-item {
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      padding: 14px 16px;
      margin-bottom: 16px;
      .contrast-title {
        font-size: 16px;
        font-weight: 700;
        color: #1b2559;
        margin-bottom: 10px;
        padding-left: 8px;
        border-left: 4px solid #0054e6;
      }
      .contrast-content {
        white-space: pre-wrap;
        word-break: break-all;
        font-size: 14px;
        line-height: 24px;
        color: #434343;
      }
    }
  }
}
</style>
